module.exports = __webpack_public_path__ + "img/vertical_3_2_5012.2bed2bd4.png";